export class KieneException {
    prozedurname: string;
    sqlstate: string;
    messagetext: string;
    stack: string;
    errno: number;
}
